import classNames from "classnames";
import * as React from "react";
import { ReactNode } from "react";

export function MediaText({
  children,
  media,
  reverse,
  className,
  ...props
}: {
  children: ReactNode;
  media: ReactNode;
  reverse?: boolean;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) {
  return (
    <section
      className={classNames(
        "grid lg:grid-cols-2 gap-16 p-8 items-center",
        className,
      )}
      {...props}
    >
      {media}
      <div
        className={classNames({
          "-order-1": reverse,
        })}
      >
        {children}
      </div>
    </section>
  );
}
